import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Checkbox } from "../Checkbox/Checkbox";
import PropTypes from "prop-types";
import classes from "./DashboardSidebarWithCalendar.module.css";
import { Switch } from "../Switch/Switch";
import MonthSmallCalander from '../../components/MonthSmallCalander';
import moment from "moment";

export const DashboardSidebarWithCalendar = ({
  totalHeading1,
  totalHeading2,
  totalValue1,
  totalValue2,
  renderLocations,
  isSelectRange,
  //   States
  setLocations,
  locations,
  setCalendarData,
  calendarData,
  customStyle,
  isShowHeader,
}) => {
  const [range, setRange] = useState(false);
  const [date, setDate] = useState(new Date());
  return (
    <div
      className={`${[classes.sidebar].join(" ")}`}
      style={{ background: Colors.neutralShadesOfWhiteSmoke, ...customStyle }}
    >
      <Row>
        {isShowHeader && totalHeading1 && totalHeading2 && (
          <Col md={12}>
            <div className={classes.header}>
              <div>
                <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                  {totalHeading1}
                </p>
                <h4
                  style={{
                    ...Fonts.h4,
                    fontSize: "26px",
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  {totalValue1}
                </h4>
              </div>
              <div
                style={{
                  borderLeft: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
              />
              <div>
                <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                  {totalHeading2}
                </p>
                <h4
                  style={{
                    ...Fonts.h4,
                    fontSize: "26px",
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  {totalValue2}
                </h4>
              </div>
            </div>
          </Col>
        )}
        <Col md={12} className={classes.calendarCol}>
          <MonthSmallCalander value={date} setValue={setDate} eventArray={[moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]} />
        </Col>
        {/* Select Range */}
        {isSelectRange && (
          <Col md={12}>
            <div
              className={classes.selectRange}
              style={{
                borderTopColor: Colors.neutralShadesOfGainsboro,
                borderBottomColor: Colors.neutralShadesOfGainsboro,
              }}
            >
              <p
                style={{
                  ...Fonts.input2,
                  lineHeight: "16px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Select Range
              </p>
              <Switch setter={setRange} value={range} />
            </div>
          </Col>
        )}
        {renderLocations?.length > 0 && (
          <Col md={12}>
            <div className={classes.locations}>
              <h6
                style={{
                  ...Fonts.h7,
                  color: Colors.neutralShadesOfNero,
                  fontFamily: "inter-600",
                  lineHeight: "24px",
                }}
              >
                Location
              </h6>
              {renderLocations?.map((item) => {
                return (
                  <div className={classes.mt16}>
                    <Checkbox
                      label={item}
                      value={locations}
                      setValue={setLocations}
                    />
                  </div>
                );
              })}
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

DashboardSidebarWithCalendar.propTypes = {
  totalValue1: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  totalValue2: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  totalHeading1: PropTypes.string,
  totalHeading2: PropTypes.string,
  renderLocations: PropTypes.array,
  isSelectRange: PropTypes.bool,
  setLocations: PropTypes.func,
  locations: PropTypes.array,
  setCalendarData: PropTypes.func,
  // Not Confirmed Type
  calendarData: PropTypes.array,
};

DashboardSidebarWithCalendar.defaultProps = {
  totalHeading1: "Total requests",
  totalHeading2: "Total Evaluations",
  totalValue1: "0",
  totalValue2: "0",
  renderLocations: ["Royal Tennis Court", "Green Tennis Court"],
  isSelectRange: false,
};
